import * as React from 'react'
import styled, { keyframes } from 'styled-components'

// @ts-ignore @todo add apprioprate declaration file
import logo from '../images/icon.png'

const rotate = keyframes`
  to {
    transform: rotate(360deg);
  }
`

export const PlaceHolder = () => (
  <LoadingWrapper aria-hidden role="none">
    <img src={logo} alt="logo" />
  </LoadingWrapper>
)
export const TablePlaceHolder = () => (
  <TableLoadingWrapper aria-hidden role="none">
    <img src={logo} alt="logo" />
  </TableLoadingWrapper>
)

const LoadingWrapper = styled.div`
  img {
    animation: ${rotate} 3s linear infinite;
  }
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`
const TableLoadingWrapper = styled.div`
  img {
    animation: ${rotate} 3s linear infinite;
  }
  display: flex;
  position: absolute;
  top: 50%;
  right: 50%;
  flex: 1;
  justify-content: center;
  align-items: center;
`

const withLoading = (WrappedComponent) => ({
  ready,
  Indicator = PlaceHolder,
  ...props
}) => {
  if (!ready) return <Indicator />

  return <WrappedComponent {...props} />
}

export default withLoading
